import { EyeClosedIcon,EyeIcon  } from 'lucide-react'
import { forwardRef, useState } from 'react'

import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'

// interface PasswordInputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

export const PasswordInput = forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  function PasswordInputRef(props, ref) {
    const [showPassword, setShowPassword] = useState(false)

    const handleShowPasswordClick = () => setShowPassword(!showPassword)

    return (
      <div className="relative">
        <Input ref={ref} type={showPassword ? 'text' : 'password'} {...props} />

        <Button
          type="button"
          variant="ghost"
          size="icon"
          className="absolute right-0 top-0 h-full px-3 py-2 hover:bg-transparent"
          aria-label={showPassword ? 'Skrýt heslo' : 'Zobrazit heslo'}
          onClick={handleShowPasswordClick}
        >
          {showPassword ? (
            <EyeIcon className='size-5' color='black' />
          ) : (
            <EyeClosedIcon className='size-5' color='black' />
          )}
        </Button>
      </div>
    )
  },
)
